import { KeyboardOutlined, KeyboardHideOutlined } from "@material-ui/icons";
import React, { InputHTMLAttributes, DetailedHTMLProps, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import CloseIconButton from "./CloseIconButton";
interface ITextInputHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  secondDiv?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  onChange?: any;
  placeholder?: any;
  isTressEmployee?: boolean;
  keyboardOptions?: any;
  keyboardOnclick?: any;
  keyboardClassName?: string;
  keyboardCssStyle?: React.CSSProperties;
  isKeyboardOpen?: boolean;
  onClickShowKeyboard?: any;
  onClickCloseKeyboard?: any;
  showKeyboardRight?: boolean;
  isKeyboardCaps?: boolean;
}

const TextInputHookFormWithKB: React.FC<ITextInputHookForm> = ({
  type = "text",
  className = "border border-gray-300 col-span-2",
  secondDiv = "grid grid-cols-1 md:grid-cols-3",
  disabled = false,
  required = false,
  register,
  label,
  pattern,
  title,
  min,
  maxLength,
  onChange,
  placeholder,
  isTressEmployee,
  keyboardOnclick,
  keyboardClassName = "",
  keyboardOptions,
  keyboardCssStyle = { right: "850px", top: "275px" },
  isKeyboardOpen = false,
  onClickShowKeyboard,
  onClickCloseKeyboard,
  showKeyboardRight = false,
  isKeyboardCaps,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`${secondDiv} w-full items-center gap-1 relative`}>
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}:
          </label>
        )}
        <input
          className={`${className} block w-full px-1 py-1 rounded-sm bg-white text-login bg-clip-padding 
          leading-normal outline-none focus:ring-septenary focus:border-septenary ${
            disabled && "opacity-50"
          }`}
          onChange={onChange}
          disabled={disabled}
          type={type}
          pattern={pattern}
          title={title}
          min={min}
          maxLength={maxLength}
          placeholder={placeholder}
          {...register}
          {...props}
        />
        {isTressEmployee && (
          <button
            type="button"
            className={`absolute right-1 p-2 text-gray-600 hover:text-black ${
              disabled && "opacity-50"
            }`}
            disabled={disabled}
            onClick={onClickShowKeyboard}
          >
            {isKeyboardOpen ? (
              <KeyboardHideOutlined className="w-5 h-5" />
            ) : (
              <KeyboardOutlined className="w-5 h-5" />
            )}
          </button>
        )}
        {isKeyboardOpen && (
          <div
            className={`origin-top-right ${
              showKeyboardRight ? `kb-align-side` : `kb-align-below`
            } bg-white border border-gray-300 rounded-lg box-shadow p-4 z-10 ${keyboardClassName} 
          `}
          >
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-sm font-bold text-blue-700">
                Special Characters
              </h3>
              <CloseIconButton onClick={onClickCloseKeyboard} />
            </div>
            <div className="grid grid-cols-4 gap-2">
              {keyboardOptions &&
                keyboardOptions?.map((char, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        isKeyboardCaps && char.value === "capital"
                          ? "w-10 h-10 flex items-center justify-center text-sm font-semibold bg-blue-300 text-blue-900 rounded-lg shadow-md hover:bg-blue-100 active:bg-blue-200  cursor-pointer"
                          : "w-10 h-10 flex items-center justify-center text-sm font-semibold bg-blue-50 text-blue-900 rounded-lg shadow-md hover:bg-blue-100 active:bg-blue-200  cursor-pointer"
                      }
                      data-value={char?.value}
                      onClick={keyboardOnclick}
                      onDragLeave={onClickCloseKeyboard}
                    >
                      {char.label}
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TextInputHookFormWithKB;
